module.exports = {"brand":"Voice Caddie","clubName":"Haevichi Country Club Seoul"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/intro.json
// module id = l2+2
// module chunks = 2